import React, { useState } from "react";
import { Avatar } from "./Ui";

export default function ThreadMessage({ message, defaultOpen }) {
  const [open, setOpen] = useState(!!defaultOpen);
  const name = message.from || message.fromEmail || "Unknown sender";
  const to = (message.to || []).join(", ");
  return (
    <article className={`ob-msg ${message.isExternal ? "is-external" : ""}`}>
      <button type="button" className="ob-msg__head" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <Avatar name={message.from} email={message.fromEmail} size={28} />
        <div className="ob-msg__who">
          <div className="ob-msg__name">
            {name}
            {message.isExternal && <span className="ob-msg__tag">external</span>}
          </div>
          <div className="ob-msg__sub">
            {message.fromEmail && message.from !== message.fromEmail ? `${message.fromEmail}` : ""}
            {to ? `${message.fromEmail ? " · " : ""}to ${to}` : ""}
            {message.cc && message.cc.length ? ` · cc ${message.cc.join(", ")}` : ""}
          </div>
        </div>
        {message.date && <span className="ob-msg__date">{message.date}</span>}
        <svg className={`ob-msg__chev ${open ? "is-open" : ""}`} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {open && <div className="ob-msg__body">{message.body || <span className="ob-muted">(empty)</span>}</div>}
    </article>
  );
}
